import * as aor from "react-admin";
import React, { Component } from "react";
import myRestClient from "../common/restClient";
import Select from "react-select";
import { Field } from "redux-form";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { submit } from "redux-form";
import CircularProgress from "@material-ui/core/CircularProgress";
import classnames from "classnames";
import ContentSave from "@material-ui/icons/Save";
import { withStyles, createStyles } from "@material-ui/core/styles";
import { showNotification, translate } from "ra-core";
import { CREATE } from "react-admin";
import { Button } from "@material-ui/core";
import tccStyles from "../common/styles";
import AutoCompleteInputOld from "./AutoCompleteInputOld";
const companyOptions = {
    resource: "companies",
    display: "name",
    label: "Aziende collegate",
    placeholder: "Aziende",
    isMulti: true
};
const styles = ({ spacing }) =>
    createStyles({
        button: {
            position: "relative"
        },
        leftIcon: {
            marginRight: spacing.unit
        },
        icon: {
            fontSize: 18
        }
    });
export const CREATE_USER = "CREATE_USER";
export const createUserAction = (id, data, basePath) => {
    return {
        type: CREATE_USER,
        payload: { id, data: { ...data } },
        meta: {
            resource: "users",
            fetch: CREATE,
            onSuccess: {
                notification: {
                    body: "user_created",
                    level: "info"
                },
                redirectTo: "/users",
                basePath
            },
            onFailure: {
                notification: {
                    body: "errore",
                    level: "warning"
                }
            }
        }
    };
};
export class CreateUserForm extends Component {
    state = {
        disableButton: false,
        inst_types: [],
        company_licenses: [],
        lic_sel: [],
        instTypeSelectDisabled: true,
        typeWarning: false
    };

    componentDidMount() {
        const params = {
            filter: this.props.filter,
            no_user_filter: true,
            pagination: { page: 1, perPage: 10000 },
            sort: { field: "id", order: "asc" }
        };
        myRestClient("GET_LIST", "installation_types", params).then(
            result => {
                const data = result.data.map(item => {
                    return {
                        id: item.id,
                        name: item.name,
                        licenses: item.licenses
                    };
                });
                this.setState({ inst_types: data });
            },
            error => {
                console.log(error);
            }
        );
    }

    getStyle = () => {
        return {
            menuPortal: provided => ({
                ...provided,
                zIndex: 9999
            }),
            option: (provided, state) => ({
                ...provided,
                color: tccStyles.colors.black,
                padding: 20,
                backgroundColor: state.isSelected
                    ? tccStyles.colors.lightgrey
                    : tccStyles.colors.white,
                ":active": {
                    backgroundColor:
                        state.isSelected || state.isFocused
                            ? tccStyles.colors.lightgrey
                            : tccStyles.colors.white
                },
                ":hover": {
                    backgroundColor: tccStyles.colors.lightgrey
                }
            }),
            control: (provided, state) => ({
                ...provided,
                borderRadius: 0,
                borderTop: state.isFocused ? 0 : 0,
                borderRight: state.isFocused ? 0 : 0,
                borderLeft: state.isFocused ? 0 : 0,
                borderBottom:
                    this.state.selectValue &&
                    this.state.selectValue.length === 0
                        ? tccStyles.fields.borders.bottomBorderError
                        : tccStyles.fields.borders.bottomBorder,
                // This line disable the blue border
                boxShadow: state.isFocused ? 0 : 0,
                "&:hover":
                    this.state.selectValue &&
                    this.state.selectValue.length === 0
                        ? tccStyles.fields.borders.bottomBorderError
                        : tccStyles.fields.borders.bottomBorderHover
            }),
            indicatorSeparator: () => ({
                display: "none"
            }),
            dropdownIndicator: (provided, state) => ({
                color: tccStyles.colors.main
            }),
            placeholder: (provided, state) => ({
                ...provided,
                // workaround for matching actual style
                marginLeft: -6.5,
                marginTop: 5
            }),
            menu: (provided, state) => ({
                ...provided,
                position: "relative",
                zIndex: 1100
            }),
            singleValue: (provided, state) => ({
                ...provided,
                marginTop: 5,
                marginLeft: this.state.selected === false ? -6.5 : 0
            }),
            multiValue: (provided, state) => ({
                ...provided,
                borderRadius: 25,
                height: 32,
                textAlign: "center"
            }),
            multiValueLabel: (provided, state) => ({
                ...provided,
                marginTop: 5,
                color: tccStyles.colors.black
            })
        };
    };

    renderLabel() {
        let mylabel = `Tipi installazione *`;
        if (this.state.typeWarning) {
            mylabel = "Campo obbligatorio: scegliere almeno un tipo";
        }
        return (
            <div
                style={{
                    fontSize: "12px",
                    color: this.state.typeWarning
                        ? tccStyles.colors.error
                        : tccStyles.colors.main,
                    visibility: true
                    //this.state.lic_sel.length === 0 ? "hidden" : null
                }}
            >
                {mylabel}
            </div>
        );
    }

    renderInstallationTypeSelect() {
        return (
            <div>
                <div>{this.renderLabel()}</div>
                <Select
                    source="installation_type_id"
                    label="resources.installations.fields.installation_type_id"
                    options={this.state.company_licenses}
                    readonly={this.state.instTypeSelectDisabled}
                    value={this.state.lic_sel}
                    styles={this.getStyle()}
                    isMulti
                    placeholder={"Tipi *"}
                    onChange={value => this.setState({ lic_sel: value })}
                />
            </div>
        );
    }

    handleOk = event => {
        const { submit } = this.props;
        this.setState({ disableButton: true });
        // Trigger a submit of our custom quick create form
        // This is needed because our modal action buttons are oustide the form
        submit("record-form");
    };

    handleSubmit = values => {
        if (this.state.lic_sel.length === 0) {
            this.setState({ typeWarning: true });
            return;
        }
        const valuesOnly = this.state.lic_sel.map(el => {
            return el.value;
        });
        values["installation_types"] = valuesOnly;
        this.props.createUser(this.props.id, values);
    };

    getOptLic = licenses => {
        if (licenses.length > 0) {
            return licenses
                .filter(license =>
                    this.state.inst_types.some(
                        inst_type => inst_type.id === license
                    )
                )
                .map(license => {
                    const inst_type = this.state.inst_types.find(
                        inst_type => inst_type.id === license
                    );
                    return {
                        value: inst_type.id,
                        label: inst_type.name
                    };
                });
        }
        return [];
    };

    setCompanyValue = value => {
        let arr = value.map(el => el.data.installation_type_ids);
        const flatArray = arr.flat();
        const uniqueIds = Array.from(new Set(flatArray));
        let lic_sel = this.state.lic_sel.map(el => el.value);
        lic_sel = lic_sel.filter(item => uniqueIds.includes(item));
        if (uniqueIds.length > 0) {
            this.setState({
                company: value.label,
                instTypeSelectDisabled: false,
                company_licenses: this.getOptLic(uniqueIds),
                lic_sel: this.getOptLic(lic_sel)
            });
        } else {
            this.setState({
                company: null,
                instTypeSelectDisabled: true,
                company_licenses: this.getOptLic([]),
                lic_sel: this.getOptLic([])
            });
        }
    };

    PostCreateToolbar = props => {
        const { className, classes = {} } = this.props;
        const disabled = this.state.disableButton;
        return (
            <aor.Toolbar {...props}>
                <Button
                    {...props}
                    className={classnames(classes.button, className)}
                    redirect="show"
                    variant="raised"
                    color={disabled ? "default" : "primary"}
                    onClick={this.handleOk}
                    disabled={disabled}
                >
                    {disabled ? (
                        <CircularProgress
                            size={18}
                            thickness={2}
                            className={classes.leftIcon}
                        />
                    ) : (
                        React.cloneElement(<ContentSave />, {
                            className: classnames(
                                classes.leftIcon,
                                classes.icon
                            )
                        })
                    )}
                    SALVA{" "}
                </Button>
            </aor.Toolbar>
        );
    };
    render() {
        return (
            <aor.CreateController {...this.props}>
                {({ save, saving }) => {
                    return (
                        <aor.SimpleForm
                            toolbar={<this.PostCreateToolbar {...this.props} />}
                            redirect="list"
                            save={save}
                            onSubmit={this.handleSubmit}
                        >
                            <aor.TextInput
                                source="username"
                                validate={[aor.required(), aor.email()]}
                            />
                            <aor.TextInput
                                source="surname"
                                validate={[aor.required()]}
                            />
                            <aor.TextInput
                                source="name"
                                validate={[aor.required()]}
                            />
                            <div>
                                <Field
                                    name="company_ids"
                                    component={AutoCompleteInputOld}
                                    {...{
                                        options: companyOptions,
                                        callBack: this.setCompanyValue
                                    }}
                                />
                            </div>
                            <div style={{ width: "25%", marginTop: "30px" }}>
                                {this.renderInstallationTypeSelect()}
                            </div>
                        </aor.SimpleForm>
                    );
                }}
            </aor.CreateController>
        );
    }
}
const enhance = compose(
    translate,
    connect(
        undefined,
        {
            showNotification,
            submit,
            createUser: createUserAction
        }
    ),
    withStyles(styles)
);
export default enhance(CreateUserForm);



// WEBPACK FOOTER //
// ./src/components/CreateUserForm.js